<template>
    <div id="navigation">
        <nav>
            <div class="nav-wrapper black">
                <div class="container">
                    <router-link to="/" class="brand-logo">Team</router-link>
                    <ul class="right">
                        <!-- <li v-if="isLoggedIn"><span class="email">{{currentUser}}</span></li> -->
                        <!-- <li v-if="!isLoggedIn"><router-link to="/TrainerRegister">Registrieren</router-link></li> -->
                        <li v-if="!isLoggedIn">
                            <router-link to="/TrainerLogin">
                                <button class="btn">Login</button>
                            </router-link>
                        </li>
                        <li v-if="isLoggedIn"><button v-on:click="logout" class="btn-small black">Logout</button></li>
                    </ul>
                </div>
            </div>
        </nav>
            <!-- <ul class="sidenav" id="mobile-demo">
                <li v-if="isLoggedIn"><span class="email">{{currentUser}}</span></li>
                <li v-if="!isLoggedIn"><router-link to="/TrainerRegister">Registrieren</router-link></li>
                <li v-if="!isLoggedIn">
                    <router-link to="/TrainerLogin">
                        <button class="btn">Login</button>
                    </router-link>
                </li>
                <li v-if="isLoggedIn"><button v-on:click="logout" class="btn grey">Logout</button></li>
            </ul> -->
    </div>
</template>

<script>

import firebase from 'firebase';

export default {
    name: 'TheNavigation',
    data() {
        return {
            isLoggedIn: false,
            currentUser: false,
        }
    },
    created() {
        if(firebase.auth().currentUser) {
            this.isLoggedIn = true;
            this.currentUser = firebase.auth().currentUser.email;
        }
    },
    methods: {
        logout: function() {
            firebase.auth().signOut().then(() => {
                this.$router.push('/TrainerLogin');
            });
        }
    },
    // // Initialize Materialize Sidebar
    // // See: https://materializecss.com/navbar.html
    // mounted() {
    //     $(document).ready(function(){
    //         $('.sidenav').sidenav();
    //     });
    // },
}

</script>

<style scoped>
    .email {
        padding-right: 10px;
        padding-left: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/TheNavigation.vue